export const getTableParams = (t) => {
  const getFields = () => {
    const fields = [
      { name: 'id', title: t('buttons.Номер'), width: 100 },
      { name: 'name', title: t('grid.Название'), width: 280 },
      { name: 'comment', title: t('filter.Комментарий') },
    ];

    return fields;
  };

  return { getFields };
};
